import Column from '@components/layout/Column'
import Container from '@components/layout/Container'
import FullScreenSection from '@components/layout/FullScreenSection'
import Row from '@components/layout/Row'
import useMediaQuery, { maxWidthQueries, minWidthQueries } from '@operations/utils/useMediaQuery'
import Link from 'next/link'
import React from 'react'
import ProgressiveImage from 'react-progressive-image'
import styled from 'styled-components'

const ImageTextImageWrap = styled(Column)`
  order: ${({ order }) => order};
`
const ImageTextImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  width: 100%;
`
const ImageTextContent = styled(Column)`
  order: ${({ order }) => order};
`
const ImageTextTitle = styled.h2`
  @media ${minWidthQueries.md} {
    font-size: ${({ theme }) => theme.font.fontSize.xxLarge};
  }
  ${({ align }) => `text-align: ${align}`};
  ${({ color }) => `color: ${color}`};
  font-family: ${({ theme }) => theme.font.fontFamily.skyclimbers};
`
const ImageTextDescription = styled.p`
  width: 100%;
  font-size: ${({ theme }) => theme.font.fontSize.large};
  @media ${minWidthQueries.md} {
    font-size: ${({ theme }) => theme.font.fontSize.xLarge};
  }
  font-family: ${({ theme }) => theme.font.fontFamily.skyclimbers};
`

const ImageText = ({ content }) => {
  const isMobile = useMediaQuery(maxWidthQueries.sm)

  const hasImage = content.image?.formats?.medium?.url
  const imageOrder = content.imageRight ? 2 : 1
  const sectionLink = content.link
  let bioWidth = '50%'
  if (!hasImage) bioWidth = '70%'
  if (isMobile) bioWidth = '100%'
  const component = (
    <Container direction={isMobile ? 'column' : 'row'} height="100%">
      <Row justify={!hasImage && 'center'}>
        {hasImage && (
          <ImageTextImageWrap
            align="center"
            height="100%"
            justify="center"
            order={isMobile ? 1 : imageOrder}
            padding="1rem"
            width={isMobile ? '100%' : '50%'}
          >
            <ProgressiveImage
              placeholder={content.image?.formats?.thumbnail?.url}
              src={content.image?.formats?.medium?.url}
              style={{
                height: content.image.formats.medium?.height,
                width: content.image.formats.medium?.width,
              }}
            >
              {(src, loading) => (
                <ImageTextImage
                  alt={content.image.alternativeText}
                  src={src}
                  style={{ filter: loading ? 'blur(2px)' : '' }}
                />
              )}
            </ProgressiveImage>
          </ImageTextImageWrap>
        )}
        <ImageTextContent
          align="center"
          height="100%"
          justify="flex-start"
          order={isMobile ? 2 : 1}
          padding="1rem"
          width={bioWidth}
          wrap="wrap"
        >
          <div>
            <ImageTextTitle align={hasImage ? '' : 'center'} color={content.color}>
              {content.title}
            </ImageTextTitle>
            <ImageTextDescription>
              {content.description}
              {sectionLink && (
                <>
                  <br />
                  <br />
                  Explore more {content.title}
                </>
              )}
            </ImageTextDescription>
          </div>
        </ImageTextContent>
      </Row>
    </Container>
  )
  return (
    <FullScreenSection
      key={content.id}
      direction="column"
      height="auto"
      overflow="initial"
      padding={isMobile ? '2rem 0' : '5rem 0'}
      wrap="wrap"
    >
      {sectionLink ? (
        <Link href={content.link}>
          <a style={{ color: 'initial' }}>{component}</a>
        </Link>
      ) : (
        component
      )}
    </FullScreenSection>
  )
}

export default ImageText
